const copyTextClass = 'copy-text';
const copiedClass = 'copy-text--copied';
const copyTextElements = [...document.querySelectorAll(`.${copyTextClass}`)];

const copyText = (text, element) => {
  // navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text);

    element.classList.add(copiedClass);
    setTimeout(() => {
      element.classList.remove(copiedClass);
    }, 800);
  } else {
    console.error('Navigator clipboard api needs a secure context (https)!');
  }
};

(() => {
  if (copyTextElements.length > 0) {
    copyTextElements.forEach((element) => {
      element.addEventListener('click', () => {
        const textToCopy =
          element.querySelector(`.${copyTextClass}-input`)?.value ?? null;
        if (textToCopy) {
          copyText(textToCopy, element);
        }
      });
    });
  }
})();
